import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SaveService } from '../../../../../services/save.service';
import { DialogService } from '../../../../../services/dialog.service';
import { HttpClient } from '@angular/common/http';
import { Utils } from '../../../../../utils/utils';
import { ToastrService } from 'ngx-toastr';
import { FocusPlanHistoryDialogComponent } from '../focusplan-history-dialog/focusplan-history-dialog.component';

@Component({
    selector: 'focusplanstatus-list',
    templateUrl: './focusplanstatus-list.component.html',
    styleUrls: ['./focusplanstatus-list.component.less',
        '../../../../../style/new-generic-styles.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*', })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ],
    standalone: false
})
export class FocusPlanListStatusComponent implements OnInit {

    @Input('measuresInfo') measuresInfo!: MeasureInfo[];
    @Input('waveId') waveId!: number;
    @Input('isEditModeEnabled') isEditModeEnabled!: boolean;
    @Input('statusesQX') statusesQX!: any[];
    @Output() refresh = new EventEmitter<string>();
    updatedItems: any[] = []
    editedStatusComments: any[] = [];
    updatedStatusQX: any[] = [];

    columnsToDisplay = ['arrow', 'Name', 'Description', 'Kpi', 'StatusQX', 'measureStatusHistory'];
    subcolumnsToDisplay = ['ItemNo', 'Description', 'Owner', 'Comments', 'Deadline', 'StatusQ1', 'StatusQ2', 'StatusQ3', 'StatusQ4', 'FinalStatus', 'StatusComments', 'actionStatusHistory'];

    public dataSource = new MatTableDataSource<MeasureInfo>();

    public isAllCollapsed: boolean = false;

    expandedElements = new Set();

    dialogRef: any;

    onRefresh: any;

    statuses!: any[]

    constructor(
        private saveService: SaveService
        , private dialogForm: MatDialog
        , private dialog: DialogService
        , private http: HttpClient
        , @Inject('BASE_URL') private baseUrl: string
        , private toastrService: ToastrService
    ) { }

    ngOnInit(): void {
        Utils.httpGetAvailableStatuses(
            this.http
            , this.baseUrl
            , this
            , function (tthis: FocusPlanListStatusComponent, result: any[]) {
                tthis.statuses = result
            },
            null
        );
    }

    ngOnChanges(changes: any) {
        if (this.statuses && this.measuresInfo) {
            this.measuresInfo.forEach(x => {
                x.ActionItems.forEach(y => {
                    y.StatusDescQ1 = this.statuses?.find(z => y.StatusQ1 === z.StatusId)?.Description
                    y.StatusDescQ2 = this.statuses?.find(z => y.StatusQ2 === z.StatusId)?.Description
                    y.StatusDescQ3 = this.statuses?.find(z => y.StatusQ3 === z.StatusId)?.Description
                    y.StatusDescQ4 = this.statuses?.find(z => y.StatusQ4 === z.StatusId)?.Description
                    y.FinalStatusDesc = this.statuses?.find(z => y.FinalStatus === z.StatusId)?.Description
                })
            })
        }

        if (this.statusesQX && this.measuresInfo) {
            this.measuresInfo.forEach(x => {
                x.StatusQXDesc = this.statusesQX?.find(z => x.StatusQXId === z.StatusQXId)?.Description
            })
        }

        if (this.statuses || this.statusesQX) {
            this.dataSource.data = this.measuresInfo
        }
    }

    pushPopElement(element: MeasureInfo) {
        if (this.expandedElements.has(element.MeasureId)) {
            this.expandedElements.delete(element.MeasureId);
        }
        else {
            this.expandedElements.add(element.MeasureId);
        }
    }

    checkExpanded(element: MeasureInfo): boolean {
        return this.expandedElements.has(element.MeasureId);
    }

    onChange(actionItemId: number, statusId: number, quarter: number, actionItemStatusId: number) {
        const index = this.updatedItems.findIndex(
            (obj) =>
                obj.actionItemId === actionItemId &&
                obj.quarter === quarter)

        if (index > 0) {
            this.updatedItems.splice(index, 1)
        }

        this.updatedItems.push({
            actionItemId: actionItemId,
            quarter: quarter,
            statusId: statusId,
            actionItemStatusId: actionItemStatusId
        })

    }

    onStatusCommentsChange(actionItem: any, updatedComment) {
        actionItem.StatusComments = updatedComment;
        if (!this.editedStatusComments.includes(actionItem)) {
            this.editedStatusComments.push(actionItem);
        }
    }

    onStatusQXChange(measureId: number, updatedStatusQXId: number) {
        const index = this.updatedStatusQX.findIndex(
            (obj) => obj.MeasureId === measureId)

        if (index !== -1) {
            this.updatedStatusQX.splice(index, 1)
        }

        this.updatedStatusQX.push({
            measureId: measureId,
            statusQXId: updatedStatusQXId
        })
    }

    collapseOrExpandAll() {
        if (this.isAllCollapsed === false) {
            this.isAllCollapsed = true;
            this.dataSource.data.forEach((el) => {
                if (!this.checkExpanded(el)) {
                    this.pushPopElement(el);
                }
            });
        } else {
            this.isAllCollapsed = false;
            this.expandedElements.clear();
        }
    }

    onMeasureStatusHistoryDetail(measure: any) {
        const config = FocusPlanHistoryDialogComponent.createMeasureStatusConfig(measure);
        this.dialogForm.open(FocusPlanHistoryDialogComponent, {
            panelClass: 'custom-mat-dialog',
            data: config
        });
    }

    onActionStatusHistoryDetail(actionItem: any) {
        const config = FocusPlanHistoryDialogComponent.createActionStatusConfig(actionItem);
        this.dialogForm.open(FocusPlanHistoryDialogComponent, {
            panelClass: 'custom-mat-dialog',
            data: config
        });
    }

}